const createQueryStr = (str, inputs) => {
  str = str.replace("?", "");

  let queryArr = [];
  if (str.trim()) {
    queryArr = str.split("&");
  }

  let queryObj = {};

  queryArr.forEach(function (item) {
    let [prop, val] = item.split("=");
    queryObj[prop] = val;
  });

  for (const input in inputs) {
    if (inputs[input] === undefined) continue;
    queryObj[input] = inputs[input];
  }

  var queryString = Object.keys(queryObj)
    .map((key) => key + "=" + queryObj[key])
    .join("&");
  queryString = "?" + queryString;

  return queryString;
};

const createQueryFromObj = (queryObj) => {
  var queryString = Object.keys(queryObj)
    .map((key) => key + "=" + queryObj[key])
    .join("&");
  queryString = "?" + queryString;

  return queryString;
};

const getParam = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  const val = urlParams.get(name);

  return val;
};

const only = (...params) => {
  let queryString = "";
  params.forEach(function (name) {
    if (getParam(name)) {
      let sep = queryString === "" ? "?" : "&";
      queryString += sep + name + "=" + getParam(name);
    }
  });

  return queryString;
};

let queryStringExport = {
  createQueryStr: (str, inputs) => createQueryStr(str, inputs),
  createQueryFromObj: (obj) => createQueryFromObj(obj),
  getParam: (name) => getParam(name),
  only: (...params) => only(...params),
};

export default queryStringExport;
